import React, { useState, useEffect } from "react";
import ComapanyNameDetails from "../../../../components/common/forms/ComapanyNameDetails";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormOtherDetails from "../../../../components/common/forms/FormOtherDetails";
import FormRadio from "../../../../components/common/forms/FormRadio";
import FormUploadDocument from "../../../../components/common/forms/FormUploadDocument";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
import { galeru_registration_v2 } from "../GaleruRegistrationB";
import { v4 as uuidv4 } from "uuid";
import Documents from "../../../../components/common/forms/Documents";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";

import {
  galeru_registration,
  Gharelu_details_of_shareholder,
  Gharelu_upload_details,
  ghaleru_shareholder,
} from "../GaleruRegistrationForm";

import { useForm } from "react-hook-form";
import FormPayment from "../../../../components/common/forms/FormPayment";
import BackButton from "../../../../components/common/backbutton/BackButton";
import api from "../../../../api/api";
import { toast } from "react-toastify";
import DualFormRadio from "../../../../components/common/forms/DualFormRadio";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import GhareluCompanyRegistrationB from "../GhareluCompanyRegistrationB/GhareluCompanyRegistrationB";

const GhareluCompanyRegistrationA = () => {
  const { register, handleSubmit, unregister } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);
  const [shareHolders, setShareHolders] = useState([
    {
      ...ghaleru_shareholder,
      id: uuidv4(),
    },
  ]);
  const [typeChange, setTypeChange] = useState(true);
  const [changeForm, setChangeForm] = useState(true);

  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null);

  const [uploadProof, setUploadProof] = useState("");
  const [paymentRangeList, setPaymentList] = useState([]);
  const [amount, setAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);

  // For amount calculation
  useEffect(() => {
    if (amount > 0) {
      let arr = paymentRangeList.filter((item) => {
        return (
          amount >= parseInt(item.range_start) &&
          amount <= parseInt(item.range_end)
        );
      });
      console.log(arr);

      arr.length > 0 && setTotalAmount(arr[0]?.amount);
    } else {
      setTotalAmount(0);
    }
  }, [amount, paymentRangeList]);

  // getting current user
  useEffect(() => {
    api
      .get("/users/me/")
      .then((response) => {
        setDueAmount(response.due_amount);
      })
      .catch((error) => {});
  }, []);

  // for filtering by company_type and show in Modal
  useEffect(() => {
    api
      .get(
        "/services/company/registration/service-charges/?company_type=gharelu_banijya"
      )
      .then((response) => {
        // console.log(response.data)
        setPaymentList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(()=> {
    setAmount(0)
  },[typeChange])




  useEffect(() => {
    if (typeChange) {
      galeru_registration_v2.map((item) => {
        unregister(item.name);
      });
    } else {
      galeru_registration.map((item) => {
        unregister(item.name);
      });
    }
  }, [unregister, typeChange]);

  const handleClick = (data) => {
    data.share_holders = shareHolders;
    data.documents = docsOutput;

    // console.log(data)

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post("/services/company/", data)
      .then((response) => {
        // console.log(response);
        toast.success("Data Registered Successfully.");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof: uploadProof,
          company: response.data.company_id,
          transaction_type: "credit",
        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((err) => {
        // console.log(err);
        toast.error("Data Registration Failed1.");
      });
  };

  let data = [];
  // const initialState = {image:"", document_name:""}

  // creating initial state according to the length of documents
  Gharelu_upload_details.map(() => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  const formChangeA = () => {
    setChangeForm(true);
  };
  const formChangeB = () => {
    setChangeForm(false);
  };

  return (
    <div className="px-10 lg:!px-14">
      <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
        Gharelu Registration Form
      </p>
      <div className=" w-full flex flex-wrap my-4 gap-5 text-center justify-center">
        <div
          onClick={formChangeA}
          className={` ${
            changeForm === true ? "bg-primary-blue  text-white" : "bg-gray-300"
          } px-3  py-2 cursor-pointer rounded-2xl font-bold`}
        >
          बाणिज्य दर्ताको लागि
        </div>
        <div
          onClick={formChangeB}
          className={` ${
            changeForm === false ? "bg-primary-blue  text-white" : "bg-gray-300"
          } px-3  py-2 cursor-pointer rounded-2xl font-bold`}
        >
          उद्योग दर्ताको लागि
        </div>
      </div>

      {changeForm === true ? (
        <>
          <form className="">
            {(user?.user_type === "ST" || user?.user_type === "AD") && (
              <AdminSearchCustomer setUserId={setUserId} />
            )}

            <div
              className="text-primary-blue font-cola
             text-lg mt-6 flex justify-between "
            >
              <div className="underline">1. Business Name Details</div>
              <div className="">
                Firm no. : <span className="text-primary-blue">123</span>
              </div>
            </div>

            <ComapanyNameDetails register={register} />
            <p className="text-primary-blue font-Calistoga text-lg underline my-4">
              2. Others Details
            </p>
            {/* <FormRadio register={register} /> */}
            {/* <DualFormRadio/> */}

            {/* <div>
    
              <div className="border-primary-blue flex border md:w-[57%]" >
                <p className="text-primary-red px-5 py-2 font-bold  border-l sm:!w-[33%]">
                  ब्यवसायको प्रकार
                </p>
                <div className=" border-l-2 flex  border-primary-blue">
                  <div onClick={ekal} className="cursor-pointer  border-primary-blue px-1 ml-2 flex items-center my-2 rounded-2xl gap-2  bg-red-500">
                    <label htmlFor="test1" className="text-white">एकल</label>
                    <input type="radio" name="a" id='test1' />
                  </div>
                  <div onClick={bahul} className="cursor-pointer border-primary-blue px-1 ml-2 flex items-center my-2 rounded-2xl gap-2  bg-red-500 ">
                    <label htmlFor="test" className="text-white">साझेदारी
                    </label>
                    <input type="radio" name="a" id="test" />
    
                  </div>
                </div>
              </div>
    
            </div> */}
            <FormRadio register={register} setTypeChange={setTypeChange} />

            <div className=" w-full flex items-center flex-col md:flex-row gap-4 ">
              {typeChange === true ? (
                <>
                  <div className="mt-4  w-full">
                    <div className="">
                      <div className="border-2 border-b-0 border-primary-blue">
                        {galeru_registration.map((item, i) => {
                          const { name, validation, ip1, type } = item;
                          return (
                            <div
                              key={i}
                              className="border-primary-blue flex flex-col border-b md:flex-row"
                            >
                              <div className="text-primary-red font-Laila  px-5 py-2 font-bold  md:w-[28rem]">
                                {ip1}
                              </div>
                              <div className="border-primary-blue w-full py-2 pl-3 outline-none border-t md:border-t-0  md:border-l-2">
                                <input
                                  className="outline-none border-primary-blue "
                                  type={type}
                                  {...register(`${name}`, {
                                    required: false,
                                    onChange: (e) => {
                                      e.target.name === "total_capital" &&
                                        setAmount(e.target.value);
                                    },
                                  })}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="text-primary-blue max-w-3xl border border-x-2 border-b-2 border-primary-blue   text-center w-full">
                        <div className="px-5 py-2  border-primary-blue font-Laila">
                          पुँजीको आधारमा तपाईको जम्मा लाग्ने रकम
                          <span className="text-red-600">
                            रु.{totalAmount}।–
                          </span>{" "}
                          मात्र
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="mt-4 w-full">
                    <div>
                      <div className="border-2 border-b border-primary-blue">
                        {galeru_registration_v2.map((item, i) => {
                          const { name, validation, ip1, type } = item;
                          return (
                            <div
                              key={i}
                              className="border-primary-blue flex flex-col  md:flex-row"
                            >
                              <div className="text-primary-red font-Laila px-5 border-primary-blue border-b font-bold  py-2 md:w-[28rem] ">
                                {ip1}
                              </div>
                              <div className="border-primary-blue w-full py-2 pl-3 border-b  outline-none md:border-l-2">
                                <input
                                  className="outline-none text-primary-blue"
                                  type={type}
                                  {...register(`${name}`, {
                                    required: false,
                                    onChange: (e) => {
                                      e.target.name === "capital_to_invest" &&
                                        setAmount(e.target.value);
                                    },
                                  })}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="text-primary-blue max-w-3xl border-x-2 border-b-2 border-primary-blue  text-center w-full">
                        <div className="px-5 py-2 text-primary-blue font-Laila">
                          साझेदारहरुको संख्या र पुँजीको आधारमा तपाईको जम्मा
                          लाग्ने रकम{" "}
                          <span className="text-red-600">
                            {" "}
                            रु.{totalAmount}।–
                          </span>{" "}
                          मात्र
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="border-primary-red font-Laila text-primary-blue w-fit rounded-full text-sm border-2 p-2 ">
                घरेलु तथा साना उद्योग कार्यालय मार्फत वाणिज्य शाखामा ब्यवसाय
                दर्ता गर्दा लाग्ने शुल्क सम्बन्धि पूर्ण जानकारी लिनको लागि यहाँ
                <span
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModalEdit"
                  className="text-primary-red cursor-pointer"
                >
                  Click
                </span>
                गर्नुहोस ।
                <PrivateCompanyModal paymentRangeList={paymentRangeList} />
              </div>
            </div>

            <p className="text-primary-blue font-Calistoga text-lg mt-6 underline">
              3. Details of Share Holders
            </p>

            {/* detail of share holder open */}
            <DetailsOfShareHolders
              DetailShareholder={Gharelu_details_of_shareholder}
              needed_share={ghaleru_shareholder}
              setShareHolders={setShareHolders}
              shareHolders={shareHolders}
            />
            {/* details of share holder close */}
            <div className="text-primary-blue font-Calistoga text-lg my-3 underline">
              4. Main Objectives{" "}
              <span className="text-primary-blue">
                {" "}
                (कम्पनीले गर्ने मुख्य मुख्य कामहरु सहितको उद्देश्यहरु){" "}
              </span>
            </div>
            <MainObjectives register={register} />

            <p className="text-primary-blue  text-lg my-3 underline">
              5. Upload Documents{" "}
              <span className="font-Laila">
                {" "}
                ( यो ब्यसाय दर्ताको लागि आवश्यक पर्ने निम्न कागजपत्रहरु Upload
                गर्नुहोस् ।
              </span>
            </p>
            <Documents
              documents_data={Gharelu_upload_details}
              initialState={data}
              setDocument={setDocsOutput}
            />
            <div className="text-primary-blue font-Calistoga text-lg my-3 underline">
              6. Working Branch{" "}
              <span className="text-primary-blue font-Laila">
                {" "}
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन
                शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>
            <FormBranch register={register} />
            <FormButtom />
            <FormPayment
              handleSubmit={handleSubmit}
              handleClick={handleClick}
              setUploadProof={setUploadProof}
              totalAmount={totalAmount}
              dueAmount={dueAmount}
              setPaidAmount={setPaidAmount}
            />

            {/* <div className="my-2">
              <p>
                माथी उल्लेखित घरेलु दर्ता अन्तर्गतको २ नं.मा रहेको दर्ता शुल्क
                सम्बन्धि जानकारीको लागि यहाँ Click गर्नुहोस् लेखेको ठाउँमा Click
                गर्दा माथी अन्य फर्महरुमा देखाए जस्तै Pop Up हरु खुल्नेछ ।
              </p>
              <p>
                त्यसै गरी सबै फर्म भरेर Submit मा Click गरेपछि पनि अन्य फर्महरुमा
                उल्लेख गरे अनुसारकै Popup हरु खुल्नेछ ।
              </p>
            </div> */}
          </form>
        </>
      ) : (
        <>
          <GhareluCompanyRegistrationB />
        </>
      )}
    </div>
  );
};

export default GhareluCompanyRegistrationA;
